import { useState, useEffect } from 'react'
import { ProposalsProps } from '../../../lib/types';

type ProposalsData = {
    storageWithOverhead: number,
    storageWithOverheadRangeMax: number,
    storageWithOverheadUnitType: string,
    diskUtilization: number,
    diskUtilizationRangeMax: number,
    diskUtilizationUnitType: string,
    systemUtilization: number,
    systemUtilizationRangeMax: number,
    systemUtilizationUnitType: string,
    cameraStreams: number,
    cameraDataRate: string,
    clientDataRate: string,
    raidType: string
}

export const useProposalHuskyData = (proposals: ProposalsProps): ProposalsData => {

    const [proposalCalculationData, setProposalCalculationData] = useState(proposals?.calculationData?.data);    
    useEffect(() => {
        if (proposals) {
            setProposalCalculationData(proposals.calculationData?.data);            
        }
    }, [proposals]);

    const storageWithOverhead = proposalCalculationData?.huskyProposal?.storageWithOverhead?.value;
    const storageWithOverheadRangeMax = proposalCalculationData?.huskyProposal?.storageWithOverhead?.rangeMax;
    const storageWithOverheadUnitType = proposalCalculationData?.huskyProposal?.storageWithOverhead?.unitType

    const diskUtilization = proposalCalculationData?.huskyProposal?.diskUtilization?.value;
    const diskUtilizationRangeMax = proposalCalculationData?.huskyProposal?.diskUtilization?.rangeMax;
    const diskUtilizationUnitType = proposalCalculationData?.huskyProposal?.diskUtilization?.unitType

    const systemUtilization = proposalCalculationData?.huskyProposal?.systemUtilization?.value;
    const systemUtilizationRangeMax = proposalCalculationData?.huskyProposal?.systemUtilization?.rangeMax;
    const systemUtilizationUnitType = proposalCalculationData?.huskyProposal?.systemUtilization?.unitType;

    const cameraStreams = proposalCalculationData?.huskyProposal?.cameraStreams;
    const cameraDataRate = proposalCalculationData?.huskyProposal?.cameraDataRate;
    const clientDataRate = proposalCalculationData?.huskyProposal?.clientDataRate;
    const raidType = proposalCalculationData?.liveDatabase?.raidType;

    return {
        storageWithOverhead,
        storageWithOverheadRangeMax,
        storageWithOverheadUnitType,
        diskUtilization,
        diskUtilizationRangeMax,
        diskUtilizationUnitType,
        systemUtilization,
        systemUtilizationRangeMax,
        systemUtilizationUnitType,
        cameraStreams,
        cameraDataRate,
        clientDataRate, 
        raidType
    }
}